import { Component } from '@angular/core';
import { Util } from 'src/app/shared/utils/util';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  public usuarioSession = Util.getUsuarioSession();

  get anoAtual() {
    const dataAtual = new Date();
    const anoatual = dataAtual.getFullYear();
    return anoatual;
  }

  get ambienteQA() {
    return window.location.href.includes('codatahml');
  }

}
